/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxMenuComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxmenu';

/**
 * Menu
 */

export class NgcMenuComponent extends ControlComponent {
     animationShowDuration: any;
     animationHideDuration: any;
     animationHideDelay: any;
     animationShowDelay: any;
     autoCloseInterval: any;
     autoSizeMainItems: any;
     autoCloseOnClick: any;
     autoOpenPopup: any;
     autoOpen: any;
     clickToOpen: any;
     disabled: any;
     enableHover: any;
     easing: any;
     keyboardNavigation: any;
     minimizeWidth: any;
     mode: any;
     popupZIndex: any;
     rtl: any;
     showTopLevelArrows: any;
     source: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-menu',
    template: `<jqxMenu 
                [animationShowDuration] = "animationShowDuration"
                [animationHideDuration] = "animationHideDuration"
                [animationHideDelay] = "animationHideDelay"
                [animationShowDelay] = "animationShowDelay"
                [autoCloseInterval] = "autoCloseInterval"
                [autoSizeMainItems] = "autoSizeMainItems"
                [autoCloseOnClick] = "autoCloseOnClick"
                [autoOpenPopup] = "autoOpenPopup"
                [autoOpen] = "autoOpen"
                [clickToOpen] = "clickToOpen"
                [disabled] = "disabled"
                [enableHover] = "enableHover"
                [easing] = "easing"
                [keyboardNavigation] = "keyboardNavigation"
                [minimizeWidth] = "minimizeWidth"
                [mode] = "mode"
                [popupZIndex] = "popupZIndex"
                [rtl] = "rtl"
                [showTopLevelArrows] = "showTopLevelArrows"
                [source] = "source"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxMenu>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'animationShowDuration': [{ type: Input, args: ['animationShowDuration', ] },],
'animationHideDuration': [{ type: Input, args: ['animationHideDuration', ] },],
'animationHideDelay': [{ type: Input, args: ['animationHideDelay', ] },],
'animationShowDelay': [{ type: Input, args: ['animationShowDelay', ] },],
'autoCloseInterval': [{ type: Input, args: ['autoCloseInterval', ] },],
'autoSizeMainItems': [{ type: Input, args: ['autoSizeMainItems', ] },],
'autoCloseOnClick': [{ type: Input, args: ['autoCloseOnClick', ] },],
'autoOpenPopup': [{ type: Input, args: ['autoOpenPopup', ] },],
'autoOpen': [{ type: Input, args: ['autoOpen', ] },],
'clickToOpen': [{ type: Input, args: ['clickToOpen', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'enableHover': [{ type: Input, args: ['enableHover', ] },],
'easing': [{ type: Input, args: ['easing', ] },],
'keyboardNavigation': [{ type: Input, args: ['keyboardNavigation', ] },],
'minimizeWidth': [{ type: Input, args: ['minimizeWidth', ] },],
'mode': [{ type: Input, args: ['mode', ] },],
'popupZIndex': [{ type: Input, args: ['popupZIndex', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'showTopLevelArrows': [{ type: Input, args: ['showTopLevelArrows', ] },],
'source': [{ type: Input, args: ['source', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Menu Module
 */

export class NgcMenuModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcMenuComponent],
    declarations: [NgcMenuComponent, jqxMenuComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
